import BroadcastsMobile from "./BroadcastsMobile";
export default BroadcastsMobile;